import { render, staticRenderFns } from "./SupsisIcon.vue?vue&type=template&id=410f3fce&scoped=true"
import script from "./SupsisIcon.vue?vue&type=script&lang=js"
export * from "./SupsisIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f3fce",
  null
  
)

export default component.exports